module.exports = __webpack_public_path__ + "static/media/right-arrow.8b720ab9.svg";